import { FC, useMemo } from "react";
import { TranslationsContext } from "./TranslationsProvider.context.js";
import { TranslationsProviderProps } from "./TranslationsProvider.types.js";

export const TranslationsProvider: FC<TranslationsProviderProps> = ({ children, translations }): JSX.Element => {
    const value = useMemo(() => ({ translations }), [translations]);

    return <TranslationsContext.Provider value={value}>{children}</TranslationsContext.Provider>;
};
